'use client';

import { useTranslations } from 'next-intl';
import { ListPageHeader } from '@terra/ui-design-system';

export function ReportsPageHeader() {
  const t = useTranslations('proxy.reports.page');

  return <ListPageHeader title={t('title')} subtitle={t('subtitle')} />;
}
